import { useAuiState } from '@assistant-ui/react';

/** The thread a card belongs to. Read it from the card, never from the persisted active thread:
 *  a thread switch mounts the other thread's cards in the same commit that changes the main
 *  thread, while the active thread still names the one just left. */
export function useCardThreadId(): string | undefined {
  return useAuiState(({ threadListItem }) => threadListItem?.remoteId);
}
